import { ISirena } from 'modelos/src';
import { colorSirena, estadoSirena, sirenaActiva } from './sirena-estado';

/**
 * Construye un Feature GeoJSON de punto para una sirena, con las propiedades
 * que consumen las capas Mapbox (color, activa) y la isla (estado, etc.).
 * Devuelve null si la sirena no tiene coordenadas.
 */
export function sirenaFeature(
  s: ISirena,
  verActualizaciones: boolean,
): GeoJSON.Feature<GeoJSON.Point> | null {
  let coord: [number, number] | null = null;
  if (s.geojson?.coordinates?.length === 2) {
    coord = [s.geojson.coordinates[0], s.geojson.coordinates[1]];
  } else if (s.ubicacionGps?.lat != null && s.ubicacionGps?.lng != null) {
    coord = [s.ubicacionGps.lng, s.ubicacionGps.lat];
  }
  if (!coord) return null;

  return {
    type: 'Feature',
    geometry: { type: 'Point', coordinates: coord },
    properties: {
      id: s._id,
      chipId: s.chipId,
      idCliente: (s as { idCliente?: string }).idCliente ?? null,
      color: colorSirena(s, verActualizaciones),
      activa: sirenaActiva(s),
      estado: estadoSirena(s),
      online: !!s.online,
      firmware: s.versionFirmware ?? '',
      rssi: s.rssi ?? null,
    },
  };
}
